
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelEast as ObiBuoyBarrelEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-east.js';
 
 
 

 
 export const ObiBuoyBarrelEast = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-east',
   elementClass: ObiBuoyBarrelEastElement,
   events: {
     
   }
  });
 
 